import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SpecificSteelProfileForm} from '../specific-steel-profile-form';
import {EaveStrutProfile} from '../../steel-profile';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {CintacValidators} from '../../../_shared/cintac-validators';

@Component({
    selector: 'app-eave-strut-profile-form',
    templateUrl: './eave-strut-profile-form.component.html',
    styleUrls: ['../../../project/project-form-components/project-form.css']
})
export class EaveStrutProfileFormComponent implements OnInit, SpecificSteelProfileForm {
    @Input() profile: EaveStrutProfile;
    @Output() specificIsValid = new EventEmitter<boolean>();
    profileData: AbstractControl;

    formErrors = {
        'A': '',
        'B': '',
        'e': '',
        'Ez': '',
        'ixy': '',
        'Wx': '',
    };

    validationMessages = {
        'A': {
            'required': 'Ingresar valor de B.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'B': {
            'required': 'Ingresar valor de H.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'e': {
            'required': 'Ingresar valor de e.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Ez': {
            'required': 'Ingresar valor de Ez.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'ixy': {
            'required': 'Ingresar valor de ixy.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
        'Wx': {
            'required': 'Ingresar valor de Wx.',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage()
        },
    };

    constructor(private fb: FormBuilder) {
        this.profileData = this.fb.group({
            A: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            B: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            e: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Ez: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            ixy: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],
            Wx: [null, [Validators.required, CintacValidators.positiveFloatValidator()]],

        });
    }

    ngOnInit() {
        this.profileData.reset({
            A: this.profile.A,
            B: this.profile.B,
            e: this.profile.e,
            Ez: this.profile.Ez,
            ixy: this.profile.ixy,
            Wx: this.profile.Wx,
        });
        this.profileData.valueChanges.subscribe(values => this.onValueChanged());
    }

    private onValueChanged() {
        const form = this.profileData;
        this.updateProfile();
        Object.keys(this.formErrors).forEach(field => {
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    if (control.errors.hasOwnProperty(key)) {
                        this.formErrors[field] += messages[key] + ' ';
                    }
                }
            }
        });
        this.specificIsValid.emit(this.profileData.valid);
    }

    updateProfile() {
        this.profile.A = this.profileData.value.A;
        this.profile.B = this.profileData.value.B;
        this.profile.e = this.profileData.value.e;
        this.profile.Ez = this.profileData.value.Ez;
        this.profile.ixy = this.profileData.value.ixy;
        this.profile.Wx = this.profileData.value.Wx;
    }

}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-forms/eave-strut-profile-form/eave-strut-profile-form.component.ts